<svg viewBox="0 0 24 24" fill="currentColor" focusable="false" class="eea-svg">
  <!--
    12 EU-flag stars in a ring at radius 9 from centre (12, 12).
    5-point star geometry (outer R=1.4, inner r=0.535 — golden
    ratio). Reused via <symbol> so the ring is 12 <use> nodes not 12
    inline paths.
  -->
  <defs>
    <symbol id="eeaStar" overflow="visible">
      <path
        d="M 0,-1.4 L 0.31,-0.43 L 1.33,-0.43 L 0.51,0.17 L 0.82,1.13 L 0,0.54 L -0.82,1.13 L -0.51,0.17 L -1.33,-0.43 L -0.31,-0.43 Z"
      />
    </symbol>
  </defs>

  <use href="#eeaStar" x="12" y="3" />
  <use href="#eeaStar" x="16.5" y="4.21" />
  <use href="#eeaStar" x="19.79" y="7.5" />
  <use href="#eeaStar" x="21" y="12" />
  <use href="#eeaStar" x="19.79" y="16.5" />
  <use href="#eeaStar" x="16.5" y="19.79" />
  <use href="#eeaStar" x="12" y="21" />
  <use href="#eeaStar" x="7.5" y="19.79" />
  <use href="#eeaStar" x="4.21" y="16.5" />
  <use href="#eeaStar" x="3" y="12" />
  <use href="#eeaStar" x="4.21" y="7.5" />
  <use href="#eeaStar" x="7.5" y="4.21" />
</svg>
